import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import axios from "axios";
import { Alert, Form, Input, Modal } from "antd";
import { axiosErrorHandler, showSuccessNotification } from "../../../../swzutils";
const VehicleHireEmailDocketModal = ({ open, vehicleHireId, emailCsv, onComplete, onCancel }) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateErrorMessage, setStateErrorMessage] = useState(null);
    const [form] = Form.useForm();
    const onFinish = (formValues) => {
        emailPOD(formValues.emails);
    };
    const emailPOD = (emailCsv) => {
        setStateLoading(true);
        const emailAddresses = emailCsv.split(",");
        axios.post(`/admin/v1/vehicle-hires/${vehicleHireId}/documents/email-docket`, {
            emails: emailAddresses
        }).then(( /*response*/) => {
            showSuccessNotification(`${emailAddresses.length} email(s) sent`);
            onComplete();
        }).catch(error => {
            axiosErrorHandler(error, setStateErrorMessage);
        }).finally(() => {
            setStateLoading(false);
        });
    };
    return (_jsxs(Modal, { title: "Email Vehicle Hire Docket", open: open, okText: "Send Email", onOk: form.submit, onCancel: onCancel, destroyOnHidden: true, confirmLoading: stateLoading, children: [_jsx(Form, { form: form, onFinish: onFinish, layout: "vertical", children: _jsx(Form.Item, { label: "Emails (separate multiple email addresses with a comma)", name: "emails", initialValue: emailCsv, rules: [{
                            required: true,
                            message: 'Please enter an email address',
                        }], children: _jsx(Input, { type: "email", multiple: true }) }) }), stateErrorMessage &&
                _jsx(Alert, { type: "error", title: stateErrorMessage, banner: true })] }));
};
export default VehicleHireEmailDocketModal;
